import React from 'react';
import { PageLayout } from '../layout';

interface MetroConfigErrorPageProps {
  error: string;
  docId?: string | null;
  onRetry: () => void;
  onContinueWithoutConfig: () => void;
  onGoBack: () => void;
}

const MetroConfigErrorPage: React.FC<MetroConfigErrorPageProps> = ({
  error,
  docId,
  onRetry: _onRetry,
  onContinueWithoutConfig: _onContinueWithoutConfig,
  onGoBack: _onGoBack,
}) => {
  return (
    <PageLayout showHeader={false} backgroundColor="bg-white">
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-sm text-center">
          <div className="mx-auto mb-6 relative w-16 h-16">
            <span className="absolute inset-0 rounded-full bg-red-100 animate-ping" aria-hidden="true" />
            <div className="relative w-16 h-16 rounded-full bg-red-50 flex items-center justify-center">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Configuration error">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M4.93 19h14.14c1.02 0 1.66-1.106 1.15-1.99L13.15 4.51c-.51-.88-1.79-.88-2.3 0L3.78 17.01C3.27 17.894 3.91 19 4.93 19z" />
              </svg>
            </div>
          </div>

          <h2 className="text-xl font-semibold text-gray-900">Something went wrong</h2>
          <p className="mt-2 text-sm text-gray-600">We couldn’t load the metro configuration.</p>
          <p className="mt-1 text-xs text-gray-500" aria-live="polite">
            Details: {error}
          </p>
          {docId ? (
            <p className="mt-1 text-xs text-gray-500">ID: {docId}</p>
          ) : null}
        </div>
      </div>
    </PageLayout>
  );
};

export default MetroConfigErrorPage;
